import { IconButton } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

/**
 * To use Header Grid :
 * Pass a React useRef to the grid component.
 * Import Module Ag-Grid ExcelExportModule in the parent component.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.gridRef - A reference to the grid component.
 */
export const TableExcelExport = ({ gridRef, fileNameCsvExport }) => {
  const exportExcel = () => {
    const today = new Date();
    const formattedDate = `${today.getDate()}-${today.getMonth() + 1
      }-${today.getFullYear()}`;

    const exportParams = {
      fileName: `${fileNameCsvExport}_${formattedDate}`,
    };
    const api = gridRef?.current?.api || gridRef?.current; // fallback si on stocke directement l'api
    if (!api) return;
    api.exportDataAsExcel(exportParams);
  };  

  return (
    <div style={{}}>
      <IconButton
        aria-label="export"
        onClick={exportExcel}
        color="inherit"
        size="large"
      >
        <FileDownloadIcon />
      </IconButton>
    </div>
  );
};
